import { defineStore } from 'pinia'
import { mergeOptionsParams, useCreateForm, useEditForm } from "@/stores/_helpers.js";
import toasteventbus from "primevue/toasteventbus";

export const useAssetTypesStore = defineStore('assetTypes', {
  state: () => ({
    data: undefined,
    options: undefined,
  }),
  getters: {
    getAssetTypes: (state) => state.data?.data,
    getAssetTypeOptions: (state) => state.options?.data,
  },
  actions: {
    /**
     * This method should be used to return as little data as possible for use in select boxes
     *
     * @param params
     * @param silent
     * @returns {Promise<any>}
     */
    async indexAssetTypeOptions(params = {}, silent = true) {

      if (!silent)
        this.options = undefined;

      try {
        if (!this.options) {
          let qryParams = mergeOptionsParams(params, 'asset_types', ['id', 'name', 'company_id']);
          const response = await axios.get('asset-types', {params: qryParams});
          this.options = response.data;
        }

        return this.options;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async indexAssetTypes(params = {}) {
      try {
        const response = await axios.get('asset-types', {params});
        this.data = response.data;
        return this.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async createAssetType(params = {}) {
      try {
        const response = await axios.get('asset-types/create', {params});
        return useCreateForm('asset-types', response.data, { onFinish: () => this.options = undefined });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async showAssetType(assetTypeId, params = {}) {
      try {
        const response = await axios.get(`asset-types/${ assetTypeId }`, {params});
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async editAssetType(assetTypeId, params = {}) {
      try {
        const response = await axios.get(`asset-types/${ assetTypeId }/edit`, {params});
        return useEditForm(`asset-types/${ assetTypeId }`, response.data, { onFinish: () => this.options = undefined });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async deleteAssetType(assetTypeId, params = {}) {
      try {
        const response = await axios.delete(`asset-types/${ assetTypeId }`, {params});
        this.options = undefined;
        toasteventbus.emit('add', {
          summary: 'Asset Type Deleted',
          detail: `Asset Type has been deleted.`,
          severity: 'success',
          life: 3000
        });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
  },
});
